<nb-card class="dialog-card">
  <nb-card-header>
    {{
      (isEdit
        ? "pages.guardrails.dialog.editTitle"
        : scope === "bot"
          ? "pages.guardrails.dialog.newTitleBot"
          : "pages.guardrails.dialog.newTitleClient"
      ) | translate
    }}
  </nb-card-header>

  <nb-card-body>
    <div class="form-field">
      <label>
        {{ "pages.guardrails.fields.name" | translate }} *
        <nb-icon
          icon="question-mark-circle-outline"
          class="hint-icon"
          nbPopover="{{ 'pages.guardrails.hints.name' | translate }}"
          nbPopoverTrigger="hover"
          nbPopoverPlacement="bottom"
        ></nb-icon>
      </label>
      <input
        nbInput
        fullWidth
        fieldSize="small"
        [(ngModel)]="model.name"
        [placeholder]="'pages.guardrails.fields.namePlaceholder' | translate"
      />
    </div>

    <div class="form-field">
      <label>
        {{ "pages.guardrails.fields.definition" | translate }} *
        <nb-icon
          icon="question-mark-circle-outline"
          class="hint-icon"
          nbPopover="{{ 'pages.guardrails.hints.definition' | translate }}"
          nbPopoverTrigger="hover"
          nbPopoverPlacement="bottom"
        ></nb-icon>
      </label>
      <textarea
        nbInput
        fullWidth
        rows="3"
        [(ngModel)]="model.definition"
        [placeholder]="'pages.guardrails.fields.definitionPlaceholder' | translate"
      ></textarea>
    </div>

    <div class="form-field">
      <label>
        {{ "pages.guardrails.fields.examples" | translate }}
        <span class="counter" [class.counter--over]="tooManyExamples">
          {{ exampleCount }}/{{ maxExamples }}
        </span>
        <nb-icon
          icon="question-mark-circle-outline"
          class="hint-icon"
          nbPopover="{{ 'pages.guardrails.hints.examples' | translate }}"
          nbPopoverTrigger="hover"
          nbPopoverPlacement="bottom"
        ></nb-icon>
      </label>
      <textarea
        nbInput
        fullWidth
        rows="3"
        [(ngModel)]="examplesText"
        [placeholder]="'pages.guardrails.fields.examplesPlaceholder' | translate"
      ></textarea>
      <span *ngIf="tooManyExamples" class="hint hint--warning">
        {{ "pages.guardrails.fields.examplesTruncated" | translate: { max: maxExamples } }}
      </span>
    </div>

    <div class="form-row-inline">
      <div class="form-field">
        <label>
          {{ "pages.guardrails.fields.enforce" | translate }}
          <nb-icon
            icon="question-mark-circle-outline"
            class="hint-icon"
            nbPopover="{{ 'pages.guardrails.hints.enforce' | translate }}"
            nbPopoverTrigger="hover"
            nbPopoverPlacement="bottom"
          ></nb-icon>
        </label>
        <nb-select
          fullWidth
          size="small"
          [selected]="model.enforce"
          (selectedChange)="onEnforceChange($event)"
        >
          <nb-option value="hard">{{ "pages.guardrails.enforce.hard" | translate }}</nb-option>
          <nb-option value="advisory">{{ "pages.guardrails.enforce.advisory" | translate }}</nb-option>
        </nb-select>
      </div>

      <div class="form-field">
        <label>
          {{ "pages.guardrails.fields.action" | translate }}
          <nb-icon
            icon="question-mark-circle-outline"
            class="hint-icon"
            nbPopover="{{ 'pages.guardrails.hints.action' | translate }}"
            nbPopoverTrigger="hover"
            nbPopoverPlacement="bottom"
          ></nb-icon>
        </label>
        <nb-select
          fullWidth
          size="small"
          [selected]="model.action"
          (selectedChange)="onActionChange($event)"
        >
          <nb-option value="log_only">{{ "pages.guardrails.action.log_only" | translate }}</nb-option>
          <nb-option value="redirect">{{ "pages.guardrails.action.redirect" | translate }}</nb-option>
          <nb-option value="block">{{ "pages.guardrails.action.block" | translate }}</nb-option>
        </nb-select>
      </div>

      <div class="form-field">
        <label>
          {{ "pages.guardrails.fields.severity" | translate }}
          <nb-icon
            icon="question-mark-circle-outline"
            class="hint-icon"
            nbPopover="{{ 'pages.guardrails.hints.severity' | translate }}"
            nbPopoverTrigger="hover"
            nbPopoverPlacement="bottom"
          ></nb-icon>
        </label>
        <nb-select
          fullWidth
          size="small"
          [selected]="model.severity"
          (selectedChange)="onSeverityChange($event)"
        >
          <nb-option value="low">{{ "pages.guardrails.severity.low" | translate }}</nb-option>
          <nb-option value="medium">{{ "pages.guardrails.severity.medium" | translate }}</nb-option>
          <nb-option value="high">{{ "pages.guardrails.severity.high" | translate }}</nb-option>
        </nb-select>
      </div>
    </div>

    <div class="form-field" *ngIf="model.action === 'redirect'">
      <label>
        {{ "pages.guardrails.fields.redirectHint" | translate }} *
        <nb-icon
          icon="question-mark-circle-outline"
          class="hint-icon"
          nbPopover="{{ 'pages.guardrails.hints.redirectHint' | translate }}"
          nbPopoverTrigger="hover"
          nbPopoverPlacement="bottom"
        ></nb-icon>
      </label>
      <textarea
        nbInput
        fullWidth
        rows="2"
        [(ngModel)]="model.redirect_hint"
        [placeholder]="'pages.guardrails.fields.redirectHintPlaceholder' | translate"
      ></textarea>
    </div>

    <!-- Template scope: only meaningful for organisation-wide rules, which
         otherwise hit support and assist bots too. -->
    <div class="form-field" *ngIf="scope === 'client'">
      <label>
        {{ "pages.guardrails.fields.appliesTo" | translate }}
        <nb-icon
          icon="question-mark-circle-outline"
          class="hint-icon"
          nbPopover="{{ 'pages.guardrails.hints.appliesTo' | translate }}"
          nbPopoverTrigger="hover"
          nbPopoverPlacement="bottom"
        ></nb-icon>
      </label>
      <nb-toggle
        [checked]="allTemplates"
        (checkedChange)="onAllTemplatesChange($event)"
      >
        {{ "pages.guardrails.fields.allTemplates" | translate }}
      </nb-toggle>
      <nb-select
        *ngIf="!allTemplates"
        multiple
        fullWidth
        size="small"
        class="template-select"
        [selected]="model.applies_to_templates || []"
        (selectedChange)="onTemplatesChange($event)"
        [placeholder]="'pages.guardrails.fields.selectTemplates' | translate"
      >
        <!-- Names come from the canonical `enums.assistantTemplate` map so
             they stay in sync with the tutor wizard and the agent list. -->
        <nb-option *ngFor="let tpl of templateOptions" [value]="tpl">
          {{ "enums.assistantTemplate." + tpl | translate }}
        </nb-option>
      </nb-select>
    </div>

    <div class="toggle-row">
      <nb-toggle [(checked)]="model.enabled">
        {{
          (model.enabled
            ? "pages.guardrails.status.enabled"
            : "pages.guardrails.status.disabled"
          ) | translate
        }}
      </nb-toggle>
      <nb-icon
        icon="question-mark-circle-outline"
        class="hint-icon"
        nbPopover="{{ 'pages.guardrails.hints.enabled' | translate }}"
        nbPopoverTrigger="hover"
        nbPopoverPlacement="bottom"
      ></nb-icon>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <button nbButton ghost size="small" (click)="close()">
      {{ "buttons.cancel" | translate }}
    </button>
    <button
      nbButton
      status="primary"
      size="small"
      [disabled]="!canSave"
      (click)="submit()"
    >
      {{ "buttons.save" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
